<template>
    <map-base/>
</template>